import script from "./HospitalStudentProfile.vue?vue&type=script&setup=true&lang=ts"
export * from "./HospitalStudentProfile.vue?vue&type=script&setup=true&lang=ts"

import "./HospitalStudentProfile.vue?vue&type=style&index=0&id=4c93b7e1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c93b7e1"]])

export default __exports__